import { render } from "./vue-magnifier.vue?vue&type=template&id=30348511&scoped=true"
import script from "./vue-magnifier.vue?vue&type=script&lang=ts"
export * from "./vue-magnifier.vue?vue&type=script&lang=ts"

import "./vue-magnifier.vue?vue&type=style&index=0&id=30348511&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30348511"

export default script